import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "ijjp8z3p5__mask0_21940_192313",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20",
        children: _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#ijjp8z3p5__mask0_21940_192313)",
        children: [_jsx("rect", {
          x: "-2.83496",
          y: "0.5",
          width: "27",
          height: "19",
          stroke: "#152361"
        }), _jsx("rect", {
          x: "-3.08496",
          y: "0.25",
          width: "27.5",
          height: "19.5",
          rx: "1.75",
          fill: "white",
          stroke: "#F5F5F5",
          strokeWidth: "0.5"
        }), _jsx("mask", {
          id: "g53vl7att__mask1_21940_192313",
          style: {
            maskType: "luminance"
          },
          maskUnits: "userSpaceOnUse",
          x: "-4",
          y: "0",
          width: "29",
          height: "20",
          children: _jsx("rect", {
            x: "-3.08496",
            y: "0.25",
            width: "27.5",
            height: "19.5",
            rx: "1.75",
            fill: "white",
            stroke: "white",
            strokeWidth: "0.5"
          })
        }), _jsxs("g", {
          mask: "url(#g53vl7att__mask1_21940_192313)",
          children: [_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-3.33496 6.66667H24.665V0H-3.33496V6.66667Z",
            fill: "#CA2B39"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-3.33496 19.9997H24.665V13.333H-3.33496V19.9997Z",
            fill: "#2C56A2"
          })]
        }), _jsx("path", {
          d: "M0 9.87584C0 4.42156 4.42156 0 9.87584 0C15.3301 0 19.7517 4.42156 19.7517 9.87584V19.7517H9.87584C4.42156 19.7517 0 15.3301 0 9.87584Z",
          fill: "#DE2910"
        }), _jsx("path", {
          d: "M0 9.87584C0 4.42156 4.42156 0 9.87584 0C15.3301 0 19.7517 4.42156 19.7517 9.87584V19.7517H9.87584C4.42156 19.7517 0 15.3301 0 9.87584Z",
          fill: "#DE2910"
        }), _jsx("path", {
          d: "M0.249023 0H20.0007V19.7517H0.249023V0Z",
          fill: "#DA291C"
        }), _jsx("path", {
          d: "M8.27088 3.70312H11.9743V8.02381H16.295V11.7272H11.9743V16.0479H8.27088V11.7272H3.9502V8.02381H8.27088V3.70312Z",
          fill: "white"
        }), _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          stroke: "#152361"
        })]
      })]
    }))
  });
};
export default Component;
